import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HybridProPanelHelper } from '../hybrid-pro-panel.helper';

@Pipe({
  name: 'hybridProGeneratorModes',
  standalone: true,
})
export class HybridProGeneratorModesPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string): string {
    if (value === HybridProPanelHelper.SecondaryHeatGeneratorModes.MonovalentOperation) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.MONOVALENT_OPERATION'
      );
    } else if (value === HybridProPanelHelper.SecondaryHeatGeneratorModes.BivalentParallel) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.BIVALENT_PARALLEL'
      );
    } else {
      return value;
    }
  }
}
